// Vuex records module actions
import { API } from '@/config';

import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getGroupsList({ commit }) {
    try {
      const records = (await API.get('/project/agentsGroups/getListByUser')).data.data;
      commit(FILL_LIST, records);
    } catch (err) {
      console.log(err);
    }
  },
};
